export const useLocaleOrExternalPath = (path: MaybeRefOrGetter<string>) => {
  const localePath = useLocalePath();

  const link = ref(toValue(path));
  const isExternalLink = ref(getIsExternalLink(toValue(path)));

  watch(
    () => toValue(path),
    (newPath) => {
      if (getIsExternalLink(newPath)) {
        link.value = newPath;
        isExternalLink.value = true;
      } else {
        link.value = localePath(newPath);
        isExternalLink.value = false;
      }
    },
    {
      immediate: true,
    },
  );

  return { link, isExternalLink };
};
